import React from 'react';
import type { SolidButtonProps } from '@noths/polaris-client-ribbons-design-system';
import { SolidButton } from '@noths/polaris-client-ribbons-design-system';

export const PrimaryButton: React.FC<SolidButtonProps> = (props) => <SolidButton {...props} />;
